// extracted by mini-css-extract-plugin
export default {"container":"bar-indicator-icon_container__2mdUD","answered":"bar-indicator-icon_answered__2TwKk","valid":"bar-indicator-icon_valid__2Vb10"};